import React, { useState } from "react";
import "../component/modalAddStaff.css";

import { createPortal } from "react-dom";

const ModalAddStaff = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  staffObject,
}) => {
  const [staffData, setStaffData] = useState(staffObject);

  const closeModal = () => {
    setStaffData({
      staff_id: "",
      staff_name: "",
      staff_username: "",
      staff_salary: "",
      staff_bonus: "",
      staff_system_role: "",
      staff_password: "",
    });
    onCloseModal();
  };

  return createPortal(
    isShowModal && (
      <div className="modal-supplier-container">
        <div className="modal-supplier-content">
          <header className="modal-supplier-header">
            <h2 className="modal-supplier-header-title">Tambah Staff</h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-supplier-main">
            <div className="form-group-supplier">
              <div className="input-title-label-container">
                <span className="input-title-label">Nama Staff</span>
              </div>
              <div className="input-staff-field-container">
                <input
                  type="text"
                  value={staffData.staff_name ? staffData.staff_name : ""}
                  onChange={(e) =>
                    setStaffData({
                      ...staffData,
                      staff_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan nama staff"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Username Staff</span>
              </div>
              <div className="input-staff-field-container">
                <input
                  type="text"
                  value={
                    staffData.staff_username ? staffData.staff_username : ""
                  }
                  onChange={(e) =>
                    setStaffData({
                      ...staffData,
                      staff_username: e.target.value,
                    })
                  }
                  placeholder="Masukkan username staff"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Password Staff</span>
              </div>
              <div className="input-staff-field-container">
                <input
                  type="password"
                  value={
                    staffData.staff_password ? staffData.staff_password : ""
                  }
                  onChange={(e) =>
                    setStaffData({
                      ...staffData,
                      staff_password: e.target.value,
                    })
                  }
                  placeholder="Masukkan password staff"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Gaji Staff</span>
              </div>
              <div className="input-staff-field-container">
                <input
                  type="text"
                  value={staffData.staff_salary ? staffData.staff_salary : ""}
                  onChange={(e) =>
                    setStaffData({
                      ...staffData,
                      staff_salary: e.target.value,
                    })
                  }
                  placeholder="Masukkan gaji staff"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Bonus Staff</span>
              </div>
              <div className="input-staff-field-container">
                <input
                  type="text"
                  value={staffData.staff_bonus ? staffData.staff_bonus : ""}
                  onChange={(e) =>
                    setStaffData({
                      ...staffData,
                      staff_bonus: e.target.value,
                    })
                  }
                  placeholder="Masukkan bonus staff"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Staff Role</span>
              </div>
              <div className="input-staff-field-container">
                <select
                  value={staffData.staff_system_role}
                  onChange={(e) =>
                    setStaffData({
                      ...staffData,
                      staff_system_role: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Pilih Staff Role
                  </option>
                  <option value="MANAGER">MANAGER</option>
                  <option value="ADMIN">ADMIN</option>
                  <option value="SUPERVISOR">SUPERVISOR</option>
                  <option value="KASIR">KASIR</option>
                  <option value="WAREHOUSE">WAREHOUSE</option>
                </select>
              </div>
            </div>
          </main>
          <footer className="modal-staff-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                const isEditData = staffData.staff_id !== "";
                onSubmitData(staffData, isEditData);
                setStaffData({
                  staff_id: "",
                  staff_name: "",
                  staff_username: "",
                  staff_salary: "",
                  staff_bonus: "",
                  staff_system_role: "",
                });
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalAddStaff;
